import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopRight2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowTopRight2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H10V4.5H4.5V19.5H19.5V14H21V21H3V3ZM13 3H21V11H19.5V5.56066L11 14.0607L9.93934 13L18.4393 4.5H13V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowTopRight2;
